import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { GetAllProductViewd } from "../../../features/RecentlyViewed/RecentlyViewed";
import viewmore from "../../../assets/images/HomePage/arrowR.svg";
import left from "../../../assets/images/HomePage/arrowL.svg";
import backbtn from "../../../assets/images/backbutton.svg";
import {
  GetProductAlsoLike,
  GetProductJustViewdd,
  GetProductNewDrops,
  GetProductFromSeller,
  GetProductTopPicks,
  GetLibasProduct,
  GetAllChanel,
  GetAllAmina,
  GetAllPradaReEdition,
  GetAllChanelBoy,
  GetAllBottega,
  GetAllHermes,
  IsProductAlsoLike,
  IsDrops,
  IsJustView,
  IsTopPicks,
  IsProductFromSeller,
  IsProductLibas,
  GetAllProductVintage,
  IsVintage,
  IsChanel,
  IsAmina,
  IsPradaReEdition,
  IsChanelBoy,
  IsBottega,
  IsHermes,
  IsBirkin,
  GetAllBirkin,
  GetAllBurberry,
  IsBurberry,
  GetAllLV,
  GetAllDG,
  GetAllMM,
  GetAllZadig,
  GetAllDisel,
  GetAllGucci,
  IsDG,
  IsGucci,
  IsDisel,
  IsLV,
  IsMM,
  IsZadug,
  SetSelectdPage,
  SetSizeFilter,
  SetTopSizeFilter,
  SortProducts,
  AddItemrRecentlyViewed,
} from "../../../features/Products/ProductSlice";

import {
  db,
  collection,
  onSnapshot,
  query,
  orderBy,
  documentId,
} from "../../../utils/firebase/firebase.utils";
import { useTranslation } from "react-i18next";
import { useEffect, useContext, useState } from "react";
import { UserContext } from "../../../context/user.context";
import SignIn from "../../SignIn/SignIn";
import DownloadModal from "../../Modals/DownloadModal";
import ForgetPassword from "../../ForgetPassword/ForgetPassword";
import SignUp from "../../SignUp/SignUp";
import ProductCard from "../../Static/Shared/ProductCard";
import { getDocs, limit, where } from "firebase/firestore";
import LoadingComp from "../LoadingComp";
import { ScrollMenu, VisibilityContext } from "react-horizontal-scrolling-menu";
import viewall from "../../../assets/images/view-all.svg";
function JustViewed() {
  const { t, i18n } = useTranslation();

  const navigate = useNavigate();
  const { flags } = useSelector((store) => store.flags);
  const { recentlyViewedarr } = useSelector((store) => store.allproducts);
  const { productsViewed } = useSelector((store) => store.recentlyViewed);
  const dispatch = useDispatch();
  const { currentUser } = useContext(UserContext);
  //const productsViewedLength = productsViewed.slice(0, 4).length;
  const [showDownload, setShowDownload] = useState(false);
  const [showSignin, setShowSignin] = useState(false);
  const [signUp, setSignUp] = useState(false);
  const [forgetpassword, setForgetpassword] = useState(false);

  var isFlash = false;

  if (flags.filter((flag) => flag.id === "offers")[0]) {
    const endDate = flags.filter((flag) => flag.id === "offers")[0]
      .endFlashSale;
    const startDate = flags.filter((flag) => flag.id === "offers")[0]
      .startFlashSale;
    isFlash =
      "toDate" in endDate && "toDate" in startDate
        ? flags.filter((flag) => flag.id === "offers")[0].isFlashSale &&
          startDate.toDate() <= Date.now() &&
          endDate.toDate() >= Date.now()
        : false;
  }
  const [viewed, setViewed] = useState([]);
  const getOnlineJustViewedAll = async () => {
    try {
      var viewed = collection(
        db,
        "profiles",
        currentUser.uid,
        "recentlyViewedProducts"
      );
      var q = query(viewed, orderBy("date", "desc"));
      var firstDocumentSnapshots = [];

      const firstQuery = query(q, limit(50));

      firstDocumentSnapshots = await getDocs(firstQuery);
      const data = firstDocumentSnapshots.docs.map((doc) => doc.id);
      dispatch(GetAllProductViewd(data));
    } catch (e) {
      console.error(e);
    }
  };
  const getOnlineJustViewed = async () => {
    try {
      var viewed = collection(
        db,
        "profiles",
        currentUser.uid,
        "recentlyViewedProducts"
      );
      var q = query(viewed, orderBy("date", "desc"));
      var firstDocumentSnapshots = [];

      const firstQuery = query(q, limit(4));

      firstDocumentSnapshots = await getDocs(firstQuery);
      const data = firstDocumentSnapshots.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setViewed(data);
      // dispatch(
      //   GetAllProductViewd(
      //    data

      //   )
      // );
    } catch (e) {
      console.error(e);
    }
  };

  if (i18n.language == "ar") {
    var arabStyle = {
      letterSpacing: "0em",
    };
  } else {
    var arabStyle = {};
  }

  // useEffect(() => {
  //   if (currentUser != null) {

  //     getOnlineJustViewedAll()
  //      getOnlineJustViewed()

  //     // var viewed = collection(
  //     //   db,
  //     //   "profiles",
  //     //   currentUser.uid,
  //     //   "recentlyViewedProducts"
  //     // );
  //     // var q = query(viewed, orderBy("date", "desc"));
  //     // onSnapshot(q, (snapshot) => {
  //     //   dispatch(
  //     //     GetAllProductViewd(
  //     //       snapshot.docs.map((doc) => ({
  //     //         ...doc.data(),
  //     //         id: doc.id,
  //     //       }))
  //     //     )
  //     //   );
  //     // });
  //   }
  // }, [currentUser]);

  const [recentlyViewedProducts, setRecentlyViewedProducts] = useState([]);
  const [recentlyViewedProductsIds, setRecentlyViewedProductsIds] = useState(
    []
  );

  function sortProductsByDate(ids, products) {
    // Sort the ids array by date in descending order
    // ids.sort((a, b) => {
    //   return b.date.seconds - a.date.seconds || b.date.nanoseconds - a.date.nanoseconds;
    // });

    // Create a map of product IDs to their indices in the sorted ids array
    const idToIndex = new Map(ids.map((id, index) => [id.id, index]));

    // Sort the products array based on the indices in the sorted ids array (descending)
    products.sort((a, b) => {
      return idToIndex.get(b.id) - idToIndex.get(a.id);
    });

    return products;
  }

  useEffect(() => {
    if (!currentUser?.uid) return;

    const viewedRef = collection(
      db,
      "profiles",
      currentUser.uid,
      "recentlyViewedProducts"
    );
    const q = query(viewedRef, orderBy("date", "desc"), limit(30));

    const unsubscribe = onSnapshot(q, async (snapshot) => {
      // Process viewed products
      const viewedProducts = snapshot.docs
        .map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
        .sort((a, b) => {
          if (a.date.seconds !== b.date.seconds) {
            return b.date.seconds - a.date.seconds;
          }
          return b.date.nanoseconds - a.date.nanoseconds;
        });

      dispatch(GetProductJustViewdd(viewedProducts));

      // Get product IDs (limit to 30 like Flutter)
      const productIds = viewedProducts.map((doc) => doc.id).filter(Boolean);

      if (productIds.length === 0) {
        setRecentlyViewedProducts([]);
        return;
      }

      try {
        // Get product details - match Flutter's PRODUCT_LIVE filter
        const productQuery = query(
          collection(db, "product"),
          where(documentId(), "in", productIds),
          where("status", "==", "Live") // Changed to match Flutter
        );

        const productSnapshot = await getDocs(productQuery);
        const products = [];

        productSnapshot.forEach((doc) => {
          products.push({ id: doc.id, ...doc.data() });
        });

        // Sort products by view date (newest first)
        const sortedProducts = viewedProducts
          .map((viewed) => products.find((p) => p.id === viewed.id))
          .filter(Boolean); // Remove undefined if products not found

        setRecentlyViewedProducts(sortedProducts);
        dispatch(AddItemrRecentlyViewed(sortedProducts));
      } catch (error) {
        console.error("Error fetching products:", error);
        // Optional: Set error state or show toast
      }
    });

    return unsubscribe;
  }, [currentUser?.uid, dispatch]);
  function RightArrow() {
    const { isLastItemVisible, scrollNext } = useContext(VisibilityContext);

    return !isLastItemVisible ? (
      <div
        disabled={isLastItemVisible}
        className="align-items-center d-flex"
        onClick={() => scrollNext()}
      >
        {recentlyViewedProducts.length > 4 ? (
          // <img src={viewmore} className="plusbtn" />
          <div class="image-container-arrow">
            <img
              src={left}
              alt="right arrow"
              className="arrow-default rotate180"
            />
            <img src={viewmore} alt="right arrow" className="arrow-hover " />
          </div>
        ) : null}
      </div>
    ) : (
      <></>
    );
  }
  function LeftArrow() {
    const { isFirstItemVisible, scrollPrev } = useContext(VisibilityContext);

    return !isFirstItemVisible ? (
      <div
        disabled={isFirstItemVisible}
        className="align-items-center d-flex"
        onClick={() => scrollPrev()}
      >
        {recentlyViewedProducts.length > 4 ? (
          // <img src={left} className="plusbtn me-3" />
          <div class="image-container-arrow">
            <img src={left} alt="right arrow" className="arrow-default" />
            <img
              src={viewmore}
              alt="right arrow"
              className="arrow-hover rotate180"
            />
          </div>
        ) : null}
      </div>
    ) : (
      <></>
    );
  }

  // var arr = productsViewed.filter((name) => products.includes(name.id));

  // var ViewdArray = productsViewed.map(
  //   (productsView) => products.filter((name) => name.id == productsView.id)[0]
  // );

  useEffect(() => {
    dispatch(GetProductJustViewdd([]));
    dispatch(GetProductAlsoLike([]));
    dispatch(GetProductFromSeller([]));
    dispatch(GetProductNewDrops([]));
    dispatch(GetProductTopPicks([]));
    //// dispatch(GetAllProductViewd([]));
    dispatch(GetLibasProduct([]));
    dispatch(GetAllProductVintage([]));
    dispatch(GetAllChanel([]));
    dispatch(GetAllAmina([]));
    dispatch(GetAllPradaReEdition([]));
    dispatch(GetAllChanelBoy([]));
    dispatch(GetAllBottega([]));
    dispatch(GetAllHermes([]));
    dispatch(GetAllBirkin([]));
    dispatch(GetAllBurberry([]));
    dispatch(IsBurberry(false));

    dispatch(GetAllDG([]));
    dispatch(IsDG(false));

    dispatch(GetAllLV([]));
    dispatch(IsLV(false));

    dispatch(GetAllDisel([]));
    dispatch(IsDisel(false));

    dispatch(GetAllGucci([]));
    dispatch(IsGucci(false));

    dispatch(GetAllMM([]));
    dispatch(IsMM(false));

    dispatch(GetAllZadig([]));
    dispatch(IsZadug(false));
    dispatch(IsJustView(false));
    dispatch(IsDrops(false));
    dispatch(IsTopPicks(false));
    dispatch(IsProductFromSeller(false));
    dispatch(IsProductAlsoLike(false));
    dispatch(IsProductLibas(false));
    dispatch(IsVintage(false));
    dispatch(IsChanel(false));
    dispatch(IsAmina(false));
    dispatch(IsPradaReEdition(false));
    dispatch(IsChanelBoy(false));
    dispatch(IsBottega(false));
    dispatch(IsHermes(false));
    dispatch(IsBirkin(false));
  }, []);
  // console.log('productsViewed',productsViewed)
  return !currentUser || recentlyViewedProducts?.length <= 4 ? null : (
    <>
      {signUp && (
        <SignUp
          signUp={signUp}
          setSignUp={setSignUp}
          handleSignIn={showSignin}
        />
      )}
      {forgetpassword && (
        <ForgetPassword
          forgetShow={forgetpassword}
          handleforgetShow={setForgetpassword}
          handleSignIn={showSignin}
        />
      )}
      {showSignin && (
        <SignIn
          signIn={showSignin}
          handleSignIn={setShowSignin}
          handleSignUp={setSignUp}
          handleForgetpassword={setForgetpassword}
        />
      )}
      <div className=" show-modal-download">
        {showDownload && (
          <DownloadModal show={showDownload} setShow={setShowDownload} />
        )}
      </div>
      <div className="d-flex align-items-center">
        <h1
          className={`title-section px-md-5  pt-lg-5 pt-4 ${
            i18n.language == "en" ? `text-center` : `text-startAr`
          }`}
        >
          {t("JUST VIEWED")}
        </h1>
        <div style={{ flexGrow: 1 }} />
        <a
          className={`d-flex justify-content-center shoptopick px-lg-0 px-3  pt-lg-5 pt-4 me-md-5  ${
            i18n.language == "en" ? `text-center` : `text-startAr`
          }`}
          onClick={
            () =>
              navigate(`/products?topic=JustViewed`) &
              window.scrollTo({ top: 0, left: 0, behavior: "instant" })
            // dispatch(IsTopPicks(true)) &
            // navigate(`/products?topic=TopPicks`) &
            // dispatch(SetSearch("")) &
            // window.scrollTo({ top: 0, left: 0, behavior: "instant" })
          }
          style={arabStyle}
          aria-label="Shop Top Picks - View All Top Picks"
        >
          {/* <div
            className={`me-2 shoptopick ${
              i18n.language == "en" ? `text-start` : `text-startAr`
            }`}
          >
            {t("viewall")}
          </div> */}

          {i18n.language == "en" ? (
            <>
              <div
                className={`me-2 shoptopick ${
                  i18n.language == "en" ? `text-start` : `text-startAr`
                }`}
              >
                {t("viewall")}
              </div>

              <img
                src={viewall}
                style={{ width: "19px" }}
                className="plusbtn"
                alt="main"
              />
            </>
          ) : (
            <>
              {" "}
              <img
                src={backbtn}
                style={{ width: "98px" }}
                className="plusbtn"
                alt="main"
              />
            </>
          )}
        </a>
      </div>

      <h2 className="sub-section px-md-5 pt-md-2 ">{t("home-sub1")}</h2>
      {!recentlyViewedProducts || recentlyViewedProducts.length == 0 ? (
        <LoadingComp heightcomp="newdropsheight" />
      ) : (
        <div>
          {recentlyViewedProducts.length > 4 ? (
            <>
              <div className="d-md-block d-none">
                {/* <div
              className="d-flex flex-row  scroll flex-nowrap padding-inlineCards justify-content-between   px-3 px-lg-0   "
              id="style-2"
              
            > */}
                <div
                  className="  padding-inlineCards px-md-5 px-0 pb-md-5"
                  dir={i18n.dir("en")}
                >
                  <ScrollMenu
                    LeftArrow={LeftArrow}
                    RightArrow={RightArrow}
                    className="padding-inlineCards px-md-5 px-0  pt-md-5 pb-md-5 d-md-block d-none"
                    id="style-2"
                  >
                    {recentlyViewedProducts?.slice(0, 15)?.map((card) => (
                      <ProductCard
                        card={card}
                        currentUser={currentUser}
                        isFlash={isFlash}
                      />
                    ))}
                  </ScrollMenu>

                  {/* </div> */}
                </div>
              </div>
              <div className="container-fluid px-0 pt-md-0 pt-2 me-0 d-md-none d-flex ">
                {/* <div
              className="d-flex flex-row  scroll flex-nowrap padding-inlineCards justify-content-between   px-3 px-lg-0   "
              id="style-2"
              
            > */}
                <div
                  className="  d-flex flex-row  scroll flex-nowrap padding-inlineCards px-md-5 px-0  pt-md-5 pb-md-5"
                  dir={i18n.dir("en")}
                >
                  {recentlyViewedProducts.slice(0, 4).map((card) => (
                    <ProductCard
                      card={card}
                      currentUser={currentUser}
                      isFlash={isFlash}
                    />
                  ))}
                  {/* </div> */}
                </div>
              </div>
            </>
          ) : (
            <div className="container-fluid p-0 me-0 d-flex">
              {/* <div
              className="d-flex flex-row  scroll flex-nowrap padding-inlineCards   px-3 px-lg-0    pb-md-5"
              id="style-2"
            > */}
              {recentlyViewedProducts.slice(0, 4).map((card) => (
                <ProductCard
                  card={card}
                  currentUser={currentUser}
                  isFlash={isFlash}
                  setShowSignin={setShowSignin}
                />
              ))}
              {/* </div> */}
              {/* </div> */}
            </div>
          )}
        </div>
      )}
      {/* <div className="text-center pt-lg-5 pt-4">
        <button
          className="btn-shop buttonH"
          onClick={() =>
            dispatch(SetSelectdPage(0))&
            dispatch(SetSizeFilter([]))&
            dispatch(SortProducts(''))&
            dispatch(SetTopSizeFilter([]))&
            dispatch(IsJustView(true)) &
            navigate(`/products?topic=JustViewed`) &
            window.scrollTo({ top: 0, left: 0, behavior: "instant" })
          }
          aria-label="View Recently Viewed Products"
        >
         {t( "VIEW ALL")}
        </button>
      </div> */}
      <br></br>
    </>
  );
}

export default JustViewed;
